(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

	function updateFlexAlignmentCollection() {
		const csScrollBar = document.querySelector('.cs-scroll-bar');
		if (!csScrollBar) return;
		const isOverflowing = csScrollBar.scrollWidth > csScrollBar.clientWidth;
		if (!isOverflowing) {
			csScrollBar.classList.add('centered');
		} else {
			csScrollBar.classList.remove('centered');
		}
	}
	window.addEventListener('load', updateFlexAlignmentCollection);
	window.addEventListener('resize', updateFlexAlignmentCollection);
	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-personal15-popup"]) return;
  try {
    
  function initStreetGift() {
    const root = document.getElementById('mc-street-gift');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const dialog = root.querySelector('dialog');
    if (typeof dialog.showModal !== 'function') return;
    const form = root.querySelector('form');
    const entry = root.querySelector('.mcsg-entry');
    const success = root.querySelector('.mcsg-success');
    const teaser = root.querySelector('.mcsg-teaser');
    const read = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
    const write = (key, value) => { try { sessionStorage.setItem(key, String(value)); } catch {} };
    const visitKey = 'mc_street_gift_visit';
    const pendingKey = 'mc_street_gift_popup_pending';
    const requestedKey = 'mc_street_gift_requested';
    const pending = Number(read(pendingKey)) || 0;
    const justSubmitted = pending > 0 && Date.now() - pending < 1800000;
    const successful = entry.dataset.posted === 'true' && justSubmitted;
    const failed = entry.dataset.errors === 'true' && justSubmitted;
    const preview = new URLSearchParams(location.search).get('mc_popup') === '1' || root.dataset.editor === 'true';
    const issued = root.dataset.issued === 'true';
    let oldOverflow = '';
    let previousFocus;
    if (successful) { entry.hidden = true; success.hidden = false; write(pendingKey, 0); write(requestedKey, '1'); }
    function open() {
      if (dialog.open) return;
      previousFocus = document.activeElement;
      oldOverflow = document.documentElement.style.overflow;
      const photo = root.querySelector('img[data-src]');
      if (!photo.src) photo.src = photo.dataset.src;
      dialog.showModal();
      write(visitKey, '1');
      document.documentElement.style.overflow = 'hidden';
      teaser.hidden = true;
    }
    function close() { dialog.close(); }
    dialog.addEventListener('close', () => {
      document.documentElement.style.overflow = oldOverflow;
      teaser.hidden = issued || successful || read(requestedKey) === '1';
      if (previousFocus instanceof HTMLElement) previousFocus.focus({ preventScroll: true });
    });
    root.querySelector('.mcsg-close').addEventListener('click', close);
    root.querySelector('.mcsg-dismiss').addEventListener('click', close);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close();
    });
    teaser.addEventListener('click', open);
    form.addEventListener('submit', () => write(pendingKey, Date.now()));
    if (successful || failed || preview) { open(); return; }
    if (issued || read(requestedKey) === '1') return;
    if (read(visitKey) === '1') { teaser.hidden = false; return; }
    setTimeout(() => {
      teaser.hidden = false;
      if (document.visibilityState !== 'visible' || document.querySelector('dialog[open]') || document.activeElement?.matches('input, textarea, select')) return;
      open();
    }, Number(root.dataset.delay || 3) * 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStreetGift, { once: true });
  else initStreetGift();
  document.addEventListener('shopify:section:load', initStreetGift);

  } catch(e) { console.error(e); }
})();
})();
